// import React from 'react'

// export default function Box5() {
//     return (
//         <div className='w-100 col-4 '>
//              <div className="custom-roadmap-box-container p-3 rounded-3">
//                       <h1>Advanced Analytics and Reporting Tools</h1>
//                       <hr/>
//                       <p>Continuing our commitment to innovation, we introduced advanced analytics and reporting tools, empowering users to make data-driven decisions and optimize performance.</p>
                      
//                     </div>
//         </div>
//       )
// }


// Blur Box5......................................
import React from 'react';

export default function Box5() {
    return (
        <div className='w-100 col-4'>
            <div className="custom-roadmap-box-containerbox5 p-3 rounded-3 blurred">
                <h1 className="blurred-text">Advanced Analytics and Reporting Tools</h1>
                <hr className="blurred-line" />
                <p className="blurred-text">Continuing our commitment to innovation, we introduced advanced analytics and reporting tools, empowering users to make data-driven decisions and optimize performance.</p>
            </div>
        </div>
    );
}
